<div class="tab-container">
    <div class="sensor-container" *ngFor="let sensor of model.pumpSensors, let i = index">
        <div class="sensor-row">
            <div class="input-group">
                <label class="flex-center">{{ i + 1 | number:'2.0-0' }}</label>
                <div class="icon-button">
                    <i class="juc ju-delete" (click)="onRemoveBtnClicked(i)"></i>
                </div>
            </div>

            <div class="input-group col1">
                <label [for]="'sensorId' +i">ID*</label>
                <select [name]="'sensorId'+i"
                        [id]="'sensorId'+i"
                        required
                        #dynamicInput="ngModel"
                        [ngClass]="{'no-value': sensor.sensorId===undefined}"
                        [(ngModel)]="sensor.sensorId"
                        (ngModelChange)="updateSensorId($event, sensor)">
                    <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                    <ng-container *ngFor="let option of getFilteredSensorIds(i)">
                        <option [ngValue]="option.value"
                        >{{ option.value }}
                        </option>
                    </ng-container>
                </select>
            </div>

            <div class="input-group col2">
                <label [for]="'sensorName'+i">Sensorname*</label>
                <select [name]="'sensorName'+i"
                        [id]="'sensorName'+i"
                        required
                        [ngClass]="{'no-value': sensor.name===undefined}"
                        [(ngModel)]="sensor.name"
                        (ngModelChange)="onSensorNameChanged($event, i)"
                        #dynamicInput="ngModel">
                    <option [ngValue]="undefined" disabled>Bitte auswählen</option>
                    <ng-container *ngFor="let option of sensorNameOptions">
                        <option *ngIf="(!option.disabled || option.value === sensor.name) && !isSameTypeButNotEqualName(i, option)"
                                [ngValue]="option.value"
                        >{{ option.label }}
                        </option>
                    </ng-container>
                </select>
            </div>

            <app-input-image-upload
                    [id]="'pumpSensorPhoto' + i"
                    [name]="'pumpSensorPhoto' + i"
                    required
                    [imageQuality]="LOW_IMAGE_QUALITY"
                    [label]="sensor?.name ? sensor.name : 'Pumpsensor'"
                    [(ngModel)]="sensor.image"
                    #dynamicInput="ngModel">
            </app-input-image-upload>
        </div>
        <div class="sensor-params">
            <div class="input-group col1">
                <label [for]="'minValue'+i">Grenzwert*</label>
                <div class="unit-a" [ngClass]="{'has-error':showError(minValueModel)}">
                    <input [name]="'minValue'+i"
                           [id]="'minValue'+i"
                           type="number"
                           required
                           [(ngModel)]="sensor.minValue"
                           #minValueModel="ngModel"
                           placeholder="Wert"
                           #dynamicInput="ngModel"/>
                </div>
                <div class="error"><span *ngIf="showError(minValueModel)">Grenzwert ist ein Pflichtfeld.</span></div>
            </div>
            <div class="input-group col2">
                <label [for]="'sensorType'+i">Sensorart*</label>
                <select [name]="'sensorType'+i"
                        [id]="'sensorType'+i"
                        required
                        [(ngModel)]="sensor.sensorType"
                        #sensorTypeModel="ngModel"
                        [ngClass]="{'no-value': !sensor.sensorType}"
                        #dynamicInput="ngModel">
                    <option [ngValue]="undefined" disabled>Wert</option>
                    <option *ngFor="let option of sensorTypeOptionsJuconn"
                            [ngValue]="option.value">{{ option.label }}
                    </option>
                </select>
                <div class="error"><span *ngIf="showError(sensorTypeModel)">Sensorart ist ein Pflichtfeld.</span></div>
            </div>
        </div>
        <div class="sensor-params">
            <div class="input-group col1">
                <label [for]="'pumpBrand'+i">Fabrikat*</label>
                <div [ngClass]="{'has-error':showError(pumpBrand)}">
                    <input [name]="'pumpBrand'+i"
                           [id]="'pumpBrand'+i"
                           type="text"
                           required
                           [(ngModel)]="sensor.pumpBrand"
                           #pumpBrand="ngModel"
                           placeholder="Fabrikat"
                           #dynamicInput="ngModel"/>
                </div>
                <div class="error"><span *ngIf="showError(pumpBrand)">Fabrikat ist ein Pflichtfeld.</span></div>
            </div>
            <div class="input-group col2">
                <label [for]="'pumpType'+i">Typ*</label>
                <div [ngClass]="{'has-error':showError(pumpType)}">
                    <input [name]="'pumpType'+i"
                           [id]="'pumpType'+i"
                           type="text"
                           required
                           [(ngModel)]="sensor.pumpType"
                           #pumpType="ngModel"
                           placeholder="Typ"
                           #dynamicInput="ngModel"/>
                </div>
                <div class="error"><span *ngIf="showError(pumpType)">Typ ist ein Pflichtfeld.</span></div>
            </div>
        </div>
        <div class="sensor-params">
            <div class="input-group col1">
                <label [for]="'pumpElectronicallyControlled'+i">Elektronisch geregelt*</label>
                <app-input-on-off
                        [(ngModel)]="sensor.pumpElectronicallyControlled"
                        #pumpElectronicallyControlled="ngModel"
                        [name]="'pumpElectronicallyControlled'+i"
                        [id]="'pumpElectronicallyControlled'+i">
                    <span class="on">Ja</span>
                    <span class="off">Nein</span>
                </app-input-on-off>
                <div class="error"><span *ngIf="showError(pumpElectronicallyControlled)">Elektronisch geregelt ist ein Pflichtfeld.</span>
                </div>
            </div>
        </div>

        <div class="input-group">
            <label [for]="'customName'+i">Benutzerdefinierter Name</label>
            <input type="text"
                   [name]="'customName'+i"
                   [id]="'customName'+i"
                   [(ngModel)]="sensor.customName">
        </div>
    </div>


    <div class="button-container">
        <button class="secondary" type="button" (click)="onAddSensorBtnClicked()"
                [disabled]="model.pumpSensors?.length >= sensorIdOptions.length">
            <i class="ju ju-add"></i>
            Pumpensensor hinzufügen
        </button>

    </div>
</div>
<div class="field">Pflichtfelder*</div>
<app-navigation-footer
        [isBackLinkDisabled]="false"
        [backLink]="'/gateway/sensors/temperature'"
        [isNextLinkDisabled]="!validationService.isSensorsPumpValid(model)"
        [nextLink]="'/gateway/sensors/counter'"
        [isLast]="false"
></app-navigation-footer>
